import { createReducer } from '../lib/createReducer.js';

const initialState = {
  integrations: [],
  isLoading: false,
  sdkInstance: null
};

export default createReducer(initialState, {
  GET_TURNKEY_INTEGRATIONS_SUCCESS: (state, payload) => ({
    ...state,
    integrations: payload?.data || []
  }),
  SET_TURNKEY_SDK_INSTANCE: (state, payload) => ({
    ...state,
    sdkInstance: payload?.data
  }),
  SET_TURNKEY_LOADING: (state, payload) => ({
    ...state,
    isLoading: payload?.data
  })
});
